import * as React from 'react';
import classnames from 'classnames';
import { Config } from '../helpers';

export default function Wrapper(props) {
  const {format} = props;

  const classNames = {
    root: classnames({
      ['nv-banner']: true,
      ['nv-banner--image']: format === Config.Banner.Format.image,
      ['nv-banner--video']: format === Config.Banner.Format.video,
    })
  };

  return (
    <div className={classNames.root}>
      {props.children}
    </div>
  );
}
